//https://reactrouter.com/en/main/start/tutorial
//https://primereact.org/button/
//https://devexpress.github.io/devextreme-reactive/react/scheduler/docs/guides/views/
//https://fkhadra.github.io/react-toastify/positioning-toast
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactGA from "react-ga4";
import moment from "moment";
import 'moment/locale/fr';
import AppHeader from './modules/AppHeader';
import { Button } from 'primereact/button';
import { IsNullOrEmpty } from "../services/CustomService";
import { hub } from "../data/loca/rentals";
import { getCurrentUser } from "../data/auth.service";
import '../assets/css/global.css';
import { getAccount } from "../data/accounts";
import { deleteRecentEventNotifications, getEventNotificationCounts, getRecentEventNotifications, markRecentEventNotificationsRead } from "../data/events";
import {
    HubConnectionBuilder,
    HubConnectionState
} from '@microsoft/signalr';
import {
    Outlet,
    NavLink,
    useLoaderData,
    useLocation,
    useNavigation,
    redirect,
    Form
} from "react-router-dom";
import { getRentals } from "../data/loca/rentals";
import { deleteRentalDraft, getRentalDrafts } from "../data/loca/rentalDrafts";
import { getUpcomingMerchandisePurchaseReminders } from "../data/loca/merchandise";
import { notify, send } from "../services/NotificationService";

export async function action() {
    return redirect(`/ajouter`);
}
export async function loader() {

    var host = window.location.host
    var subdomain = host.split('.')[0]
    if (subdomain === 'location') { /* redirection pour l'ancien domaine location.jox.ac */
        return redirect("https://lokapp.fr" + window.location.pathname);
    }

    const acc = await getAccount();
    let user = getCurrentUser()

    return { user, acc };

}

const OLD_LOCAL_DRAFT_THRESHOLD_MS = 15 * 24 * 60 * 60 * 1000; // 15 jours

function isOldLocalDraft(draft) {
    const raw = draft?.updatedAt || draft?.createdAt;
    if (!raw) {
        return false;
    }
    const time = new Date(raw).getTime();
    if (Number.isNaN(time)) {
        return false;
    }
    return Date.now() - time > OLD_LOCAL_DRAFT_THRESHOLD_MS;
}

export default function Root() {
    if (window.location.href.indexOf("localhost") === -1) {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: window.location.pathname });
    }
    useEffect(() => {
        const updateHeaderVisibility = () => {
            document.body.classList.toggle('hide-header-first-line', window.scrollY > 0);
        };
        updateHeaderVisibility();
        window.addEventListener('scroll', updateHeaderVisibility, { passive: true });
        return () => {
            window.removeEventListener('scroll', updateHeaderVisibility);
            document.body.classList.remove('hide-header-first-line');
        };
    }, []);
    const { user, acc } = useLoaderData();
    const location = useLocation();
    const navigation = useNavigation();
    const [rentals, setRentals] = useState([]);
    const [loadingRentals, setLoadingRentals] = useState(true);
    const boardId = user.publicId;
    const roles = Array.isArray(user?.roles) ? user.roles : [];
    const isAdmin = roles.includes('Admin');
    const [adminMenuOpen, setAdminMenuOpen] = useState(false);
    const [localDrafts, setLocalDrafts] = useState([]);
    const [showOldLocalDrafts, setShowOldLocalDrafts] = useState(false);
    const [collapsedReservationSections, setCollapsedReservationSections] = useState({
        drafts: true,
        localDrafts: true,
        ongoing: true,
        upcoming: true
    });
    const [eventCounts, setEventCounts] = useState({ user: 0, admin: 0 });
    const [eventMenuOpen, setEventMenuOpen] = useState(false);
    const [eventItems, setEventItems] = useState([]);
    const [merchandisePurchaseReminders, setMerchandisePurchaseReminders] = useState([]);
    const eventMenuOpenRef = useRef(eventMenuOpen);
    var ongoingArray = [];
    var upcomingArray = [];
    var draftArray = [];

    const mapDraft = (draft) => {
        let payload = {};
        try {
            payload = draft.json ? JSON.parse(draft.json) : {};
        } catch (error) {
            payload = {};
        }
        return {
            id: draft.publicId,
            createdAt: draft.createdAtUtc,
            updatedAt: draft.updatedAtUtc,
            displayName: draft.displayName,
            // Picto du premier outil du brouillon (fourni par l'API a partir du materiel enregistre).
            picture: draft.picture || "",
            toolName: draft.toolName || "",
            values: payload.values || {}
        };
    };

    const fetchDrafts = async () => {
        const drafts = await getRentalDrafts();
        if (!Array.isArray(drafts)) {
            setLocalDrafts([]);
            return;
        }
        setLocalDrafts(drafts.map(mapDraft));
    };

    const removeLocalDraft = async (draftId) => {
        await deleteRentalDraft(draftId);
        await fetchDrafts();
        window.dispatchEvent(new Event("rental-drafts-updated"));
    };

    const getRentalAttentionLabel = (rental) => [
        rental.missingElectronicSignature ? "signature manquante" : null,
        rental.missingAdvancePayment ? "acompte manquant" : null
    ].filter(Boolean).join(" + ");
    const isReservationSectionCollapsed = (section) => collapsedReservationSections[section] !== false;
    const toggleReservationSection = (section) => {
        setCollapsedReservationSections((current) => ({
            ...current,
            [section]: !isReservationSectionCollapsed(section)
        }));
    };
    const renderReservationSectionTitle = (section, label, count) => (
        <button
            type="button"
            className="lk-side-section__title sidebar-reservation-section-toggle"
            onClick={() => toggleReservationSection(section)}
            aria-expanded={!isReservationSectionCollapsed(section)}
        >
            <span>{label}</span>
            <span className="lk-side-section__meta">
                {count > 0 && <span className="lk-side-count">{count}</span>}
                <i className={`pi ${isReservationSectionCollapsed(section) ? "pi-chevron-down" : "pi-chevron-up"}`} aria-hidden="true"></i>
            </span>
        </button>
    );

    useEffect(() => {
        setUpSignalRPublicApiConnection(boardId).then((con) => { });


        if (acc.needComplementaryInfo || IsNullOrEmpty(acc.address) || IsNullOrEmpty(acc.city) || IsNullOrEmpty(acc.zipcode)) {
            // notify
            send("warn", "Veuillez compléter vos informations avant de continuer...");
        }

        const smartsuppTimeout = window.setTimeout(() => {
            window._smartsupp = window._smartsupp || {};
            window._smartsupp.key = "85a110aca561627c21640b24b8e3f44e53bb530a";

            if (!window.smartsupp) {
                (function (d) {
                    var s, c, o = function () { o._.push(arguments) };
                    o._ = [];
                    s = d.getElementsByTagName("script")[0];
                    c = d.createElement("script");
                    c.type = "text/javascript";
                    c.charset = "utf-8";
                    c.async = true;
                    c.src = "//www.smartsuppchat.com/loader.js?";
                    c.onload = () => {
                        if (window.smartsupp) {
                            window.smartsupp("name", acc.firstname + " " + acc.lastname);
                            window.smartsupp("email", acc.email);
                            window.smartsupp("phone", acc.phone);
                        }
                    };
                    s.parentNode.insertBefore(c, s);
                    c.email = acc.email
                })(document);

            }
        }, 1500);

        return () => {
            window.clearTimeout(smartsuppTimeout);
        };

    }, []);

    useEffect(() => {
        let isMounted = true;

        const fetchActiveRentals = async () => {
            try {
                const activeRentals = await getRentals();
                if (!isMounted) {
                    return;
                }
                const normalizedRentals = Array.isArray(activeRentals) ? activeRentals : [];
                setRentals(normalizedRentals);
                localStorage.removeItem("activeRentals");
                localStorage.setItem("activeRentals", JSON.stringify(normalizedRentals));
                window.dispatchEvent(new CustomEvent("active-rentals-updated"));
            } catch (error) {
                if (isMounted) {
                    setRentals([]);
                }
            } finally {
                if (isMounted) {
                    setLoadingRentals(false);
                }
            }
        };

        const fetchMerchandisePurchaseReminders = async () => {
            try {
                const reminders = await getUpcomingMerchandisePurchaseReminders();
                if (isMounted) {
                    setMerchandisePurchaseReminders(Array.isArray(reminders) ? reminders : []);
                }
            } catch (error) {
                if (isMounted) {
                    setMerchandisePurchaseReminders([]);
                }
            }
        };

        const fetchEventCounts = async () => {
            try {
                const counts = await getEventNotificationCounts();
                if (!isMounted || !counts) {
                    return;
                }
                setEventCounts({
                    user: counts.user ?? 0,
                    admin: counts.admin ?? 0,
                    adminByCode: counts.adminByCode ?? {},
                    pendingListings: counts.pendingListings ?? 0,
                    moderationPending: counts.moderationPending ?? 0
                });
            } catch (error) {
                if (isMounted) {
                    setEventCounts({ user: 0, admin: 0 });
                }
            }
        };

        if (!IsNullOrEmpty(localStorage.getItem("user"))) {
            fetchActiveRentals();
            fetchEventCounts();
            fetchMerchandisePurchaseReminders();
        } else {
            setLoadingRentals(false);
        }

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        let isMounted = true;

        const fetchEvents = async () => {
            try {
                const events = await getRecentEventNotifications(10);
                if (!isMounted || !Array.isArray(events)) {
                    return;
                }
                setEventItems(events);
            } catch (error) {
                if (isMounted) {
                    setEventItems([]);
                }
            }
        };

        if (eventMenuOpen) {
            fetchEvents();
        }

        return () => {
            isMounted = false;
        };
    }, [eventMenuOpen]);

    useEffect(() => {
        let isMounted = true;

        const markRead = async () => {
            try {
                await markRecentEventNotificationsRead(10);
                const counts = await getEventNotificationCounts();
                if (isMounted && counts) {
                    setEventCounts({
                        user: counts.user ?? 0,
                        admin: counts.admin ?? 0,
                        adminByCode: counts.adminByCode ?? {},
                        pendingListings: counts.pendingListings ?? 0,
                        moderationPending: counts.moderationPending ?? 0
                    });
                }
            } catch (error) {
                if (isMounted) {
                    setEventCounts((prev) => ({ ...prev }));
                }
            }
        };

        if (eventMenuOpen) {
            markRead();
        }

        return () => {
            isMounted = false;
        };
    }, [eventMenuOpen]);

    useEffect(() => {
        setAdminMenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        notify();
    }, [location.pathname]);

    useEffect(() => {
        eventMenuOpenRef.current = eventMenuOpen;
    }, [eventMenuOpen]);

    const playNotificationSound = () => {
        try {
            const AudioContextRef = window.AudioContext || window.webkitAudioContext;
            if (!AudioContextRef) {
                return;
            }
            const audioContext = new AudioContextRef();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();
            oscillator.type = "sine";
            oscillator.frequency.value = 880;
            gainNode.gain.setValueAtTime(0.001, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.08, audioContext.currentTime + 0.02);
            gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.2);
            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);
            oscillator.start();
            oscillator.stop(audioContext.currentTime + 0.22);
        } catch (error) {
            // ignore sound errors
        }
    };

    useEffect(() => {
        fetchDrafts();

        const handleLocalDraftUpdate = () => {
            fetchDrafts();
        };

        window.addEventListener("rental-drafts-updated", handleLocalDraftUpdate);

        return () => {
            window.removeEventListener("rental-drafts-updated", handleLocalDraftUpdate);
        };
    }, []);

    const setUpSignalRPublicApiConnection = async (boardId: string) => {

        var hubLink = await hub();

        const publicApiconnection = new HubConnectionBuilder()
            .withUrl(hubLink + 'lokappdhub') // publicAPI
            .withAutomaticReconnect()
            .build();

        publicApiconnection.on('RentalsUpdated', (s) => {
            const updatedRentals = Array.isArray(s) ? s : [];
            setRentals(updatedRentals);
            setLoadingRentals(false);
            localStorage.removeItem("activeRentals");
            localStorage.setItem("activeRentals", JSON.stringify(updatedRentals));
            window.dispatchEvent(new CustomEvent("active-rentals-updated"));

        });

        publicApiconnection.on('EventNotificationsUpdated', async () => {
            try {
                const counts = await getEventNotificationCounts();
                if (counts) {
                    setEventCounts({
                        user: counts.user ?? 0,
                        admin: counts.admin ?? 0,
                        adminByCode: counts.adminByCode ?? {},
                        pendingListings: counts.pendingListings ?? 0,
                        moderationPending: counts.moderationPending ?? 0
                    });
                }
                if (eventMenuOpenRef.current) {
                    const events = await getRecentEventNotifications(10);
                    if (Array.isArray(events)) {
                        setEventItems(events);
                    }
                }
                playNotificationSound();
            } catch (error) {
                // ignore update errors
            }
        });

        try {
            await publicApiconnection.start();
        } catch (err) {
            console.log(err);
        }

        if (publicApiconnection.state === HubConnectionState.Connected) {
            publicApiconnection.invoke('SubscribeToRental', boardId).catch((err: Error) => {
                return console.error(err.toString());
            });
        }

        return publicApiconnection;
    };
    // on split les location en cours et les locations à venir
    const rentalsList = Array.isArray(rentals) ? rentals : [];
    rentalsList.forEach(rental => {
        if (rental.status === 'InProgress') {
            ongoingArray.push(rental);
        } else if (rental.status === 'Draft') {
            draftArray.push(rental);
        }
        else {
            upcomingArray.push(rental);
        }
        // trier ongoingArray par endDate
        ongoingArray.sort(function (a, b) {
            return new Date(a.endDate) - new Date(b.endDate);
        });

        // trier upcomingArray par startDate
        upcomingArray.sort(function (a, b) {
            return new Date(a.startDate) - new Date(b.startDate);
        });
    });

    // recuperation de la premier lettre

    // On recupere les statistiques des locations par service du mois précédent (du 1er jusqu'a la fin du mois)
    const format1 = "YYYY-MM-DD"

    let startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    startDate.setDate(1);
    let startDateformattedDate = moment(startDate).format(format1);

    let endDate = new Date();
    endDate.setDate(1);
    endDate.setHours(-1);
    let endDateformattedDate = moment(endDate).format(format1);
    var statLink = '/stats/' + startDateformattedDate + "/" + endDateformattedDate;
    const adminDropdownItems = [
        { label: "Validation annonces", mobileLabel: "Validation", to: "/annonces/validation", icon: "pi pi-check-square" },
        { label: "Gestion annonces", mobileLabel: "Gestion", to: "/annonces/gestion", icon: "pi pi-cog" },
        { label: "Utilisateurs", to: "/user/list", icon: "pi pi-users" },
        { label: "Plateformes", to: "/administration/plateformes", icon: "pi pi-globe" },
        { label: "Statistiques", mobileLabel: "Stats", to: "/administration/statistiques", icon: "pi pi-chart-bar" },
        { label: "Carte des annonces", mobileLabel: "Carte", to: "/administration/carte-annonces", icon: "pi pi-map" },
        { label: "Matériel de saison", mobileLabel: "Saison", to: "/administration/materiel-saison", icon: "pi pi-star" },
        { label: "Messages AlloVoisins", mobileLabel: "AlloVoisins", to: "/administration/messages-allovoisins", icon: "pi pi-comments" },
        { label: "Automatisation AlloVoisins", mobileLabel: "Automation", to: "/administration/automation-allovoisins", icon: "pi pi-bolt" },
        { label: "QR codes", to: "/administration/scans-qr", icon: "pi pi-qrcode" },
        { label: "Modération", mobileLabel: "Modération", to: "/administration/moderation", icon: "pi pi-flag" },
        { label: "Satisfaction", mobileLabel: "Satisfaction", to: "/administration/satisfaction", icon: "pi pi-star" }
    ];
    const userEventCount = eventCounts.user;

    // Badge admin par sous-menu : file d'attente REELLE pour les annonces à
    // valider et les signalements (etat courant, jamais fantome), et
    // notifications non lues pour les nouveaux utilisateurs / scans QR.
    const adminByCode = eventCounts.adminByCode || {};
    const adminBadgeFor = (to) => {
        switch (to) {
            case "/annonces/validation": return eventCounts.pendingListings || 0;
            case "/user/list": return adminByCode.AdminNewUser || 0;
            case "/administration/scans-qr": return adminByCode.AdminQrCodeScanned || 0;
            case "/administration/moderation": return eventCounts.moderationPending || 0;
            default: return 0;
        }
    };
    // Badge parent = somme des sous-badges -> jamais de pin parent sans sous-menu.
    const adminEventCount = [
        "/annonces/validation",
        "/user/list",
        "/administration/scans-qr",
        "/administration/moderation",
    ].reduce((sum, to) => sum + adminBadgeFor(to), 0);
    const toggleAdminMenu = useCallback(() => {
        setAdminMenuOpen((prev) => !prev);
    }, []);
    const closeAdminMenu = useCallback(() => {
        setAdminMenuOpen(false);
    }, []);
    const toggleEventMenu = useCallback(() => {
        setEventMenuOpen((prev) => !prev);
    }, []);
    const closeEventMenu = useCallback(() => {
        setEventMenuOpen(false);
    }, []);
    const clearEventList = async () => {
        if (!isAdmin) {
            return;
        }
        try {
            await deleteRecentEventNotifications(10);
            setEventItems([]);
            setEventCounts((prev) => ({ ...prev, user: 0, admin: 0 }));
        } catch (error) {
            notify("error", "Impossible de supprimer la liste des événements.");
        }
    };

    const purchaseReminders = Array.isArray(merchandisePurchaseReminders) ? merchandisePurchaseReminders : [];
    const purchaseReminderCount = purchaseReminders.length;
    const purchaseReminderQuantity = purchaseReminders.reduce((total, item) => total + (item.quantityToBuy ?? 0), 0);
    const purchaseReminderPreview = purchaseReminders
        .slice(0, 3)
        .map((item) => `${item.name} (${item.quantityToBuy} ${item.unit || "pièce"})`)
        .join(", ");
    const purchaseReminderNearestRentalDate = purchaseReminders
        .flatMap((item) => Array.isArray(item.rentals) ? item.rentals : [])
        .map((rental) => rental.startDate ? moment(rental.startDate) : null)
        .filter((date) => date?.isValid())
        .sort((a, b) => a.valueOf() - b.valueOf())[0];
    const purchaseReminderNearestRentalDays = purchaseReminderNearestRentalDate
        ? Math.max(0, purchaseReminderNearestRentalDate.startOf("day").diff(moment().startOf("day"), "days"))
        : null;
    const purchaseReminderNearestRentalLabel = purchaseReminderNearestRentalDays === null
        ? null
        : purchaseReminderNearestRentalDays === 0
            ? "aujourd'hui"
            : purchaseReminderNearestRentalDays === 1
                ? "demain"
                : `dans ${purchaseReminderNearestRentalDays} jours`;

    const navLinkClass = ({ isActive, isPending }) =>
        isActive ? "active" : isPending ? "pending" : "";
    const pathname = location.pathname;
    const toolMatch = pathname.match(/^\/monoutil\/([^/]+)/);
    const toolId = toolMatch ? toolMatch[1] : null;
    const isToolDetail = /^\/monoutil\/[^/]+(\/(details|assets|annexes|historique|depenses|satisfaction)(\/expense\/add)?)?$/.test(pathname);
    const isToolsSection = pathname.startsWith("/outils");
    const isToolsList = pathname === "/outils/liste";
    const isServicesSection = pathname.startsWith("/services");
    const isClientsSection = pathname.startsWith("/clients");
    const isStatsSection = pathname.startsWith("/stats");
    const isAdminSection =
        pathname.startsWith("/annonces") ||
        pathname.startsWith("/user") ||
        pathname.startsWith("/administration");
    const isReservationsSection = !isToolsSection
        && !isToolDetail
        && !isServicesSection
        && !isClientsSection
        && !isStatsSection
        && !isAdminSection;
    const nextPathname = navigation.location?.pathname || "";
    const isRentalDetailNavigation = isReservationsSection
        && navigation.state !== "idle"
        && /^\/[^/]+$/.test(nextPathname);

    const renderSidebarMenu = (title, items) => (
        <nav className="sidebar-menu" aria-label={title}>
            <h3>{title}</h3>
            <ul>
                {items.map((item) => (
                    <li key={item.label}>
                        {item.to ? (
                            <NavLink to={item.to} className={navLinkClass}>
                                <span className="sidebar-menu-icon"><i className={item.icon} aria-hidden="true" /></span>
                                <small>{item.label}</small>
                                {adminBadgeFor(item.to) > 0 && <span className="lk-badge lk-badge--inline">{adminBadgeFor(item.to)}</span>}
                            </NavLink>
                        ) : (
                            <a href={item.href}>
                                <span className="sidebar-menu-icon"><i className={item.icon} aria-hidden="true" /></span>
                                <small>{item.label}</small>
                            </a>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );

    const renderMobileMenu = (items) => (
        <nav className="sidebar-menu sidebar-menu-mobile" aria-label="Sous-navigation">
            <ul>
                {items.map((item) => {
                    const badge = item.to ? adminBadgeFor(item.to) : 0;
                    const label = item.mobileLabel || item.label;
                    return (
                        <li key={`${item.label}-mobile`}>
                            {item.to ? (
                                <NavLink to={item.to} className={navLinkClass} aria-label={item.label}>
                                    <span className="sidebar-menu-icon">
                                        <i className={item.icon} aria-hidden="true" />
                                        {badge > 0 && <span className="lk-badge">{badge}</span>}
                                    </span>
                                    <span>{label}</span>
                                </NavLink>
                            ) : (
                                <a href={item.href} aria-label={item.label}>
                                    <span className="sidebar-menu-icon"><i className={item.icon} aria-hidden="true" /></span>
                                    <span>{label}</span>
                                </a>
                            )}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );

    const mainNavItems = [
        { label: "Réservations", to: "/", icon: "pi pi-calendar", active: isReservationsSection },
        { label: "Outils", to: "/outils/liste", icon: "pi pi-wrench", active: isToolsSection || isToolDetail },
        { label: "Clients", to: "/clients/liste", icon: "pi pi-users", active: isClientsSection },
        { label: "Statistiques", to: statLink, icon: "pi pi-chart-line", active: isStatsSection }
    ];

    let sidebarContent = null;
    let mobileMenuItems = null;

    if (isReservationsSection) {
        const oldLocalDraftCount = localDrafts.filter(isOldLocalDraft).length;
        const visibleLocalDrafts = showOldLocalDrafts
            ? localDrafts
            : localDrafts.filter((draft) => !isOldLocalDraft(draft));
        const isInitialLoading = loadingRentals && rentalsList.length === 0;
        const sectionClass = (section) =>
            `lk-side-section sidebar-reservation-section${isReservationSectionCollapsed(section) ? " is-collapsed" : ""}`;

        const renderRentalLink = (rental) => (
            <NavLink to={`/${rental.id}`} className={navLinkClass}>
                {(!IsNullOrEmpty(rental.picture)) ? (
                    <img className="smallPicture" alt="" src={rental.picture} />
                ) : (
                    <div className="no-picture no-picture-small" aria-hidden="true"></div>
                )}
                <span><small>{rental.displayName}</small></span>
            </NavLink>
        );

        const renderRentalSection = (section, label, list, dataCy, emptyLabel) => (
            <nav className={sectionClass(section)} aria-label={label}>
                {renderReservationSectionTitle(section, label, list.length)}
                <div className="lk-side-section__body sidebar-reservation-section-body">
                    {list.length ? (
                        <ul className="lk-side-list" data-cy={dataCy}>
                            {list.map((rental) => {
                                const attentionLabel = getRentalAttentionLabel(rental);
                                return (
                                    <li
                                        key={rental.id}
                                        className={rental.requiresAttention ? "sidebar-rental-attention" : undefined}
                                        title={attentionLabel || undefined}
                                    >
                                        {renderRentalLink(rental)}
                                    </li>
                                );
                            })}
                        </ul>
                    ) : (
                        <p className="lk-side-empty">{emptyLabel}</p>
                    )}
                </div>
            </nav>
        );

        sidebarContent = (
            <>
                <Form action="/ajouter" className="lk-side-cta">
                    <Button data-cy="nextStepBtn" type="submit" icon="pi pi-plus" label="Nouvelle réservation" />
                </Form>

                {isInitialLoading ? (
                    <p className="lk-side-loading">
                        <i className="pi pi-spin pi-spinner" aria-hidden="true"></i>
                        <span>Chargement des réservations...</span>
                    </p>
                ) : (
                    <>
                        {draftArray.length > 0 && renderRentalSection("drafts", "À compléter", draftArray, "draftRentals", "")}

                        {localDrafts.length > 0 && (
                            <nav className={sectionClass("localDrafts")} aria-label="Non enregistrées">
                                {renderReservationSectionTitle("localDrafts", "Non enregistrées", visibleLocalDrafts.length)}
                                <div className="lk-side-section__body sidebar-reservation-section-body">
                                    <ul className="lk-side-list" data-cy="localDraftRentals">
                                        {visibleLocalDrafts.map((draft) => (
                                            <li key={draft.id}>
                                                <div className="flex align-items-center gap-2">
                                                    <NavLink
                                                        to={`/ajouter?draftId=${draft.id}`}
                                                        className={navLinkClass}
                                                        onPointerDown={() => { window.__lokappChangingDraftUntil = Date.now() + 1000; }}
                                                        onClick={() => { window.__lokappChangingDraftUntil = Date.now() + 1000; }}
                                                        title={draft.toolName || undefined}
                                                    >
                                                        {(!IsNullOrEmpty(draft.picture)) ? (
                                                            <img className="smallPicture" alt="" src={draft.picture} />
                                                        ) : (
                                                            <div className="no-picture no-picture-small" aria-hidden="true"></div>
                                                        )}
                                                        <span><small>{draft.displayName || "Brouillon local"}</small></span>
                                                    </NavLink>
                                                    <Button
                                                        text
                                                        icon="pi pi-trash"
                                                        severity="danger"
                                                        aria-label="Supprimer le brouillon"
                                                        onClick={() => removeLocalDraft(draft.id)}
                                                    />
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                    {oldLocalDraftCount > 0 && (
                                        <button
                                            type="button"
                                            className="sidebar-old-drafts-toggle"
                                            onClick={() => setShowOldLocalDrafts((value) => !value)}
                                            aria-expanded={showOldLocalDrafts}
                                        >
                                            <i className={`pi ${showOldLocalDrafts ? "pi-chevron-up" : "pi-chevron-down"}`} aria-hidden="true"></i>
                                            <span>
                                                {showOldLocalDrafts
                                                    ? "Masquer les anciens brouillons"
                                                    : `${oldLocalDraftCount} ancien${oldLocalDraftCount > 1 ? "s" : ""} brouillon${oldLocalDraftCount > 1 ? "s" : ""}`}
                                            </span>
                                        </button>
                                    )}
                                </div>
                            </nav>
                        )}

                        {renderRentalSection("ongoing", "En cours", ongoingArray, "inprogressRentals", "Aucune location en cours")}
                        {renderRentalSection("upcoming", "À venir", upcomingArray, "comingRentals", "Aucune location à venir")}
                    </>
                )}
            </>
        );
    } else if (isToolDetail && toolId) {
        const items = [
            { label: "Détails", to: `/monoutil/${toolId}/details`, icon: "pi pi-info-circle" },
            { label: "Assets", to: `/monoutil/${toolId}/assets`, icon: "pi pi-image" },
            { label: "Annexes au contrat", mobileLabel: "Annexes", to: `/monoutil/${toolId}/annexes`, icon: "pi pi-file-pdf" },
            { label: "Historique", to: `/monoutil/${toolId}/historique`, icon: "pi pi-history" },
            { label: "Dépenses", to: `/monoutil/${toolId}/depenses`, icon: "pi pi-wallet" },
            { label: "Satisfaction", to: `/monoutil/${toolId}/satisfaction`, icon: "pi pi-star" }
        ];
        mobileMenuItems = items;
        sidebarContent = renderSidebarMenu("Outil", items);
    } else if (isToolsSection) {
        const items = [
            { label: "Liste des outils", mobileLabel: "Liste", to: "/outils/liste", icon: "pi pi-list" },
            { label: "Ajouter un outil", mobileLabel: "Ajouter", to: "/outils/ajout", icon: "pi pi-plus-circle" },
            { label: "Entrepôts", to: "/outils/entrepots", icon: "pi pi-map-marker" },
            { label: "Marchandises", to: "/outils/marchandises", icon: "pi pi-shopping-bag" },
            { label: "Matériels partagés", mobileLabel: "Partagés", to: "/outils/materiels-partages", icon: "pi pi-sitemap" },
            { label: "Véhicule de livraison", mobileLabel: "Véhicule", to: "/outils/vehicule-livraison", icon: "pi pi-truck" }
        ];
        mobileMenuItems = items;
        sidebarContent = renderSidebarMenu("Outils", items);
    } else if (!isToolsList && isServicesSection) {
        const items = [
            { label: "Liste des plateformes", mobileLabel: "Liste", to: "/services/liste", icon: "pi pi-list" },
            { label: "Ajouter une plateforme", mobileLabel: "Ajouter", to: "/services/ajout", icon: "pi pi-plus-circle" }
        ];
        mobileMenuItems = items;
        sidebarContent = renderSidebarMenu("Plateformes", items);
    } else if (isClientsSection) {
        const items = [
            { label: "Liste des clients", mobileLabel: "Liste", to: "/clients/liste", icon: "pi pi-users" },
            { label: "Ajouter un client", mobileLabel: "Ajouter", to: "/clients/ajout", icon: "pi pi-user-plus" }
        ];
        mobileMenuItems = items;
        sidebarContent = renderSidebarMenu("Clients", items);
    } else if (isStatsSection) {
        const items = [
            { label: "Tableau de bord", to: statLink, icon: "pi pi-chart-line" }
        ];
        mobileMenuItems = items;
        sidebarContent = renderSidebarMenu("Statistiques", items);
    } else if (isAdminSection) {
        const items = adminDropdownItems.flatMap((item) => (
            item.to === "/administration/plateformes"
                ? [item, { label: "Ajouter une plateforme", mobileLabel: "Ajouter", to: "/administration/plateformes/ajout", icon: "pi pi-plus-circle" }]
                : [item]
        ));
        mobileMenuItems = items;
        sidebarContent = renderSidebarMenu("Administration", items);
    }

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={8000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light" />

            <AppHeader
                navItems={mainNavItems}
                isAdmin={isAdmin}
                adminItems={adminDropdownItems}
                adminActive={isAdminSection}
                adminBadgeFor={adminBadgeFor}
                adminEventCount={adminEventCount}
                adminMenuOpen={adminMenuOpen}
                onToggleAdminMenu={toggleAdminMenu}
                onCloseAdminMenu={closeAdminMenu}
                userEventCount={userEventCount}
                eventMenuOpen={eventMenuOpen}
                onToggleEventMenu={toggleEventMenu}
                onCloseEventMenu={closeEventMenu}
                eventItems={eventItems}
                onClearEvents={clearEventList}
            />

            <div className="lk-app">
                {sidebarContent && (
                    <aside id="sidebar" className={`lk-sidebar${isReservationsSection ? " sidebar-reservations" : ""}`}>
                        {sidebarContent}
                    </aside>
                )}

                <main id="detail" className={`lk-main${isRentalDetailNavigation ? " detail-loading" : ""}`}>
                    <div className="custombar2">
                        {purchaseReminderCount > 0 && (
                            <div className="merchandise-purchase-banner">
                                <div className="merchandise-purchase-banner-icon">
                                    <i className="pi pi-shopping-cart" aria-hidden="true" />
                                </div>
                                <div className="merchandise-purchase-banner-content">
                                    <strong>Marchandises à commander avant les prochaines locations</strong>
                                    <span>
                                        {purchaseReminderQuantity} article{purchaseReminderQuantity > 1 ? "s" : ""} à acheter sur {purchaseReminderCount} référence{purchaseReminderCount > 1 ? "s" : ""}{purchaseReminderNearestRentalLabel ? `, première location ${purchaseReminderNearestRentalLabel}` : ""} : {purchaseReminderPreview}{purchaseReminderCount > 3 ? "..." : ""}
                                    </span>
                                </div>
                                <NavLink to="/outils/marchandises">Voir le stock</NavLink>
                            </div>
                        )}

                        {isRentalDetailNavigation && (
                            <div className="route-loader" role="status" aria-live="polite">
                                <i className="pi pi-spin pi-spinner" aria-hidden="true" />
                                <span>Chargement de la location...</span>
                            </div>
                        )}

                        <Outlet />
                    </div>
                </main>
            </div>

            {mobileMenuItems && renderMobileMenu(mobileMenuItems)}
        </>
    );
}
